module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control filter-picker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.keywords),
      expression: "keywords",
      modifiers: {
        "trim": true
      }
    }],
    ref: "ip",
    staticClass: "filter-entry",
    class: _vm.className,
    staticStyle: {
      "color": "#6b7d8e"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": [_vm.onBlur, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "picker-wrapper"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      staticClass: "picker-item"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.onItemClick(index)
        }
      }
    }, [_vm._v(_vm._s(item[_vm.field]))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-43de3ca6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picker/filter.vue
// module id = 598
// module chunks = 1